var vendorServices = angular.module('vendorServices',['sharedServices','ngFileUpload','configService']);

vendorServices.factory('getStoreInfo',function($http,config){
	var getStoreInfo = function(token,vedorId) {
		return $http.get(config.domain + '/api/v2/vendor/get-location?vendorId='+vedorId)
	}
	return getStoreInfo;
});

vendorServices.factory('getMenus',function($http,config) {
	var getMenus = function(vendor_id) {
		return $http.get(config.domain + '/api/v1/venue/get/menu_files?version=1.1&token='+ config.vtoken +'&vendor_id='+vendor_id
)
	}
		return getMenus;
});

vendorServices.factory('callMaskNumber',function($http,config) {
	var callMaskNumber = function(offset,sort,desc) {
		return $http.get(config.domain + '/api/v1/call_mask_leads?token='+ config.vtoken+'&offset='+offset+'&sort='+sort+'&order='+desc)
	}
	return callMaskNumber;
})
vendorServices.factory('getvenueMenu',function($http,config) {
	var getvenueMenu = function(vendor_id,token) {
		return $http.get(config.domain + '/api/v1/venue/get/menu_files?version=1.1&token='+ token +'&vendor_id='+vendor_id
	)
	}
		return getvenueMenu;
})
vendorServices.factory('addStoreInfo', function($http, config) {
    var addStoreInfo = function(token,data) {
        return $http({
          method: 'post',
          url: config.domain + '/api/v2/vendor/save-location',
          data: data
        })
    }
    return addStoreInfo;
});

vendorServices.factory('addNewAlbum', function ($http, config){
	var addNewAlbum = function(token,data) {
		return $http({
			method: 'post',
			url: config.domain + '/api/v1/vendor/album/adddetail?version=1.1&token='+token,
			data:data
		})
	}
	return addNewAlbum;
});

vendorServices.factory('postUpdateAlbum', function ($http, config){
	var postUpdateAlbum = function(token,data) {
		return $http({
			method: 'post',
			url: config.domain + '/api/v1/vendor/album/editdetail?version=1.1&token='+token,
			data:data
		})
	}
	return postUpdateAlbum;
});

vendorServices.factory('editStoreInfo', function($http, config) {
    var editStoreInfo = function(token,data) {
        return $http({
          method: 'post',
          url: config.domain + '/api/v2/vendor/save-location',
          data: data
        })
    }
    return editStoreInfo;
});

vendorServices.factory('delStoreInfo', function($http, config) {
    var delStoreInfo = function(token,data) {
      return $http({
        method: 'post',
        url: config.domain + '/api/v1/vendor/delete-location',
        data: data
      })
    }
    return delStoreInfo;
});
vendorServices.factory('makeCoverPhoto', function($http, config) {
    var makeCoverPhoto = function(coverData, url) {
      return $http({
        method: 'post',
        url: config.domain + url,
        data: coverData
      })
    }
    return makeCoverPhoto;
});
vendorServices.factory('postDeleteAlbum', function($http, config) {
    var postDeleteAlbum = function(token, resource_id, project) {
      return $http({
        method: 'get',
        url: config.domain + '/api/v1/vendor/album/delete?version=1.1&id='+resource_id+'&token='+token+'&resource_name='+project+'&resource_id='+resource_id,
      })
    }
    return postDeleteAlbum;
});

vendorServices.factory('vendorInfo',function($http,config) {
	var vendorInfo = function(token) {
		return $http.get(config.domain + '/api/v1/vendor/information?version=1.1&token='+token)
	}
	return vendorInfo;
});
vendorServices.factory('deletePhotoGet',function($http,config) {
	var deletePhotoGet = function(token,imageId) {
		return $http.get(config.domain + '/api/v1/vendor/photo/delete?version=1.1&image_id='+imageId+'&token='+token)
	}
	return deletePhotoGet;
});
vendorServices.factory('updateVendorInfo',function($http,config) {
	var updateVendorInfo = function(token,vendor_id,name,contact_name,contact_email,fblink,wblink,instalink,vimeolink,base_city,category_id,phone,faq) {
		return $http({
			method: 'post',
			url: config.domain + '/api/v1/vendor/information?version=1.1&token='+token,
			data: {
				'id': vendor_id,
				'name': name,
				'contact_name': contact_name,
				'contact_email': contact_email,
				'facebookLink': fblink,
				'websiteLink': wblink,
				'base_city': base_city,
				'instaLink': instalink,
				'vimeoLink': vimeolink,
				'category_id': category_id,
				// 'information': info,
				'phone_numbers': phone,
				'faq': faq,

			}

		})
	}
	return updateVendorInfo;
});

vendorServices.factory('priceLockAddRequest',function($http,config) {
	var priceLockAddRequest = function(token, apiData) {
		return $http({
            method: 'post',
            url: config.domain + '/node/v1/pricelock/add-request',
            data: apiData,
            headers: {
                'Content-Type': 'application/json',
                'source': 1,
                'token': token
              }
        })
	}
	return priceLockAddRequest;
});


vendorServices.factory('getAlbumDetail',function($http,config) {
	var getAlbumDetail = function(token) {
		return $http.get(config.domain + '/api/v1/vendor/albums?version=1.1&token='+token)
	}
	return getAlbumDetail;
});

vendorServices.factory('leadsDashboard',function($http,config) {
	var leadsDashboard = function(token) {
		return $http.get(config.domain + '/api/v1/vendor/leads_dashboard?version=1.1&token='+token);
	}
	return leadsDashboard;
});
vendorServices.factory('leadsGraph',function($http,config) {
	var leadsGraph = function(token,vendor_id,filter,role) {
		if (role == 'ROLE_BRAND_VENDOR') {
			return $http.get(config.domain + '/api/v1/brand_leads_graph?version=1.1&token='+token+'&vendor_id='+vendor_id+'&filter='+filter);
		} else {
			return $http.get(config.domain + '/api/v1/vendor/leads_graph?version=1.1&token='+token+'&vendor_id='+vendor_id+'&filter='+filter);
		}
	}
	return leadsGraph;
});

vendorServices.factory('viewGraph',function($http,config) {
	var viewGraph = function(token,vendor_id,filter) {
		return $http.get(config.domain + '/api/v1/vendor/view_graph?version=1.1&token='+token+'&vendor_id='+vendor_id+'&filter='+filter);
	}
	return viewGraph;
});

vendorServices.factory('callsReceived',function($http,config) {
	var callsReceived = function(token,role,vendor_id) {
		if (role == 'ROLE_BRAND_VENDOR') {
			 return $http.get(config.domain + '/api/v1/brand_calls_received?version=1.1&token='+token+'&vendor_id='+vendor_id);
		} else {
			return $http.get(config.domain + '/api/v1/vendor/calls_received?version=1.1&token='+token);
		}
	}
	return callsReceived;
});
//suggestionLeads

vendorServices.factory('suggestionLeads',function($http,config) {
	var suggestionLeads = function(token,role,vendor_id) {
			return $http.get(config.domain + '/api/v1/vendor/suggestions?version=1.1&token='+token+'&vendor_id='+vendor_id);
	}
	return suggestionLeads;
})



vendorServices.factory('bookingLeads',function($http,config) {
	var bookingLeads = function(token,role,vendor_id) {
		if (role == 'ROLE_BRAND_VENDOR') {
			return $http.get(config.domain + '/api/v1/brand_booking_lead?version=1.1&token='+token+'&vendor_id='+vendor_id);
		} else {
			return $http.get(config.domain + '/api/v1/booking_lead?version=1.1&token='+token);
		}
	}
	return bookingLeads;
})

vendorServices.factory('generalEnquiry',function($http,config) {
	var generalEnquiry = function(token,role,vendor_id) {
		if (role == 'ROLE_BRAND_VENDOR') {
			 return $http.get(config.domain + '/api/v1/brand_contact_clicked?version=1.1&token='+token+'&vendor_id='+vendor_id);
		} else {
			return $http.get(config.domain + '/api/v1/vendor/contact_clicked?version=1.1&token='+token);
		}
	}
	return generalEnquiry;
});

vendorServices.factory('inboxThread',function($http,config) {
	var inboxThread = function(token) {
		return $http.get(config.domain + '/api/v1/vendor/threadlist?version=1.1&token='+token);
	}
	return inboxThread;
});

vendorServices.factory('messageReceived',function($http,config) {
	var inboxThread = function(token,role,vendor_id) {
		if (role == 'ROLE_BRAND_VENDOR') {
			return $http.get(config.domain + '/api/v1/brand_message_received?version=1.1&token='+token+'&vendor_id='+vendor_id);
		} else {
			return $http.get(config.domain + '/api/v1/vendor/message_received?version=1.1&token='+token);
		}
	}
	return inboxThread;
});

vendorServices.factory('getAllImages',function($http,config){
	var getAllImages = function(token, section, id) {
		return $http.get(config.domain + '/api/v1/vendor/album/detail?version=1.1&token='+token+'&resource_id='+id+'&resource_name='+section)
	}
	return getAllImages;
});
vendorServices.factory('membershipPlans',function($http,config) {
	var membershipPlans = function(token) {
		return $http.get(config.domain + '/api/v1/vendor/membership?version=1.1&token='+token)
	}
	return membershipPlans;
});
vendorServices.factory('changeMemb',function($http,config) {
	var changeMemb = function(token,id) {
		return $http({
			method: 'post',
			url: config.domain + '/api/v1/vendor/changemembership?version=1.1&token='+ token,
			data: {
				'id': id
			}
		})
	}
	return changeMemb;
});
vendorServices.factory('postReviewMessage',function($http,config) {
	var postReviewMessage = function(token,id,message) {
		return $http({
			method: 'post',
			url: config.domain + '/api/v1/vendor/review/reply?version=1.1&token='+ token,
			data: {
				'review_id': id,
				'comment': message
			}
		})
	}
	return postReviewMessage;
});

vendorServices.factory('postPinToTopVendorReview',function($http,config) {
	var postPinToTopVendorReview = function(token, id) {
		return $http({
			method: 'post',
			url: config.domain + '/api/v1/vendor/review/pin_to_top?version=1.1&token='+ token,
			data: {
				'review_id': id,
			}
		})
	}
	return postPinToTopVendorReview;
});

vendorServices.factory('getReviewList',function($http,config) {
	var getReviewList = function(token) {
		return $http.get(config.domain + '/api/v1/vendor/review/get?version=1.1&token='+token)
	}
	return getReviewList;
});


vendorServices.factory('getAllMessage',function($http,config) {
	var getAllMessage = function(token) {
		return $http.get(config.domain + '/api/v1/vendor/threadlist?version=1.1&token='+token)
	}
	return getAllMessage;
});

vendorServices.factory('getInboxMessage',function($http,config) {
	var getInboxMessage = function(token,threadId) {
		return $http.get(config.domain + '/api/v1/vendor/thread/message?version=1.1&thread_id='+threadId+'&token='+token)
	}
	return getInboxMessage;
});

vendorServices.factory('postReplyMessage',function($http,config) {
	var postReplyMessage = function(token,id,message) {
		return $http({
			method: 'post',
			url: config.domain + '/api/v1/vendor/reply/message?version=1.1&token='+ token,
			data: {
				'thread_id': id,
				'message': message
			}
		})
	}
	return postReplyMessage;
});

vendorServices.factory('saveMenu',function($http,config,Upload) {
	var saveMenu = function(token,vendor_id,menu,id) {
		return $http({
			method: 'post',
			url: config.domain + '/api/v1/venue/post/menu?version=1.1&token='+token+'&vendor_id='+vendor_id,
			data: {
				'title':menu.title,
				'menu_file': menu.menuFile,
				'starters': menu.starters,
				'main_course': menu.mainCourse,
				'appetisers': menu.appetisers,
				'desserts': menu.desserts,
				'price_type': menu.menuType,
				'price': menu.price,
				'non_veg_starter' : menu.non_veg_starter,
				'non_veg_maincourse': menu.non_veg_maincourse,
				'non_veg_appetiser': menu.non_veg_appetiser,
				'non_veg_dessert': menu.non_veg_dessert,
				'id': menu.id
			}

		})
	}
	return saveMenu;
});

vendorServices.factory('getMenu',function($http,config) {
	var getMenu = function(token,vendor_id) {
		return $http.get(config.domain + '/api/v1/venue/get/menu?version=1.1&token='+token+'&vendor_id='+vendor_id);
	}
	return getMenu;
});

vendorServices.factory('deleteMenu',function($http,config) {
	var deleteMenu = function(token,vendor_id,id) {
		return $http.delete(config.domain + '/api/v1/venue/delete/menu?version=1.1&token='+token+'&vendor_id='+vendor_id+'&id='+id);
	}
	return deleteMenu;
});

vendorServices.factory('deleteMenuFile',function($http,config) {
	var deleteMenu = function(token,vendor_id,id) {
		return $http.delete(config.domain + '/api/v1/venue/delete/menu_file?version=1.1&token='+token+'&vendor_id='+vendor_id+'&id='+id);
	}
	return deleteMenu;
});

vendorServices.factory('addBanquet',function($http,config) {
	var addBanquet = function(token,vendor_id,banquet,edit) {
		var bData = {
				'title' : banquet.title,
				'fixed_capacity': banquet.fixed_capacity,
				'floating_capacity': banquet.floating_capacity,
				'indoor_outdoor': Number(banquet.indoor_outdoor)
			}
		if (banquet.id) {
			bData.id = banquet.id;
		}
		return $http({
			method: 'post',
			url: config.domain + '/api/v1/venue/post/banquet?version=1.1&token='+token+'&vendor_id='+vendor_id,
			data: bData
		});
	}
	return addBanquet;
});

vendorServices.factory('getBanquet',function($http,config) {
	var getBanquet = function(token,vendor_id) {
		return $http.get(config.domain+'/api/v1/venue/get/banquet?version=1.1&token='+token+'&vendor_id='+vendor_id)
	}
	return getBanquet;
});

vendorServices.factory('deleteBanquet',function($http,config) {
	var deleteBanquet = function(token,vendor_id,id) {
		return $http.delete(config.domain + '/api/v1/venue/delete/banquet?version=1.1&token='+token+'&vendor_id='+vendor_id+'&id='+id);
	}
	return deleteBanquet;
});
vendorServices.factory('vcDetail',function($http,config) {
	var vcDetail = function(token,user_id,role,vendor_id) {
		if (role == 'ROLE_BRAND_VENDOR') {
			return $http.get(config.domain + '/api/v1/brand_contact_clicked/detail?version=1.1&token='+token+'&user_id='+user_id+'&vendor_id='+vendor_id)
		} else {
			return $http.get(config.domain + '/api/v1/vendor/contact_clicked/detail?version=1.1&token='+token+'&user_id='+user_id)
		}
	}
	return vcDetail;
});

vendorServices.factory('callHistory',function($http,config) {
	var callHistory = function(token,user_id,role,vendor_id) {
		if (role == 'ROLE_BRAND_VENDOR') {
			return $http.get(config.domain + '/api/v1/brand_call_history?user_id='+user_id+'&version=1.1&token='+token+'&vendor_id='+vendor_id)
		} else {
			return $http.get(config.domain + '/api/v1/vendor/call_history?user_id='+user_id+'&version=1.1&token='+token)
		}
	}
	return callHistory;
});

vendorServices.factory('oldQuote',function($http,config) {
	var oldQuote = function(token,role,vendor_id) {
		if (role == 'ROLE_BRAND_VENDOR') {
			return $http.get(config.domain + '/api/v1/brand_old_quote?version=1.1&token='+token+'&vendor_id='+vendor_id);
		} else {
			return $http.get(config.domain + '/api/v1/vendor/old_quote?version=1.1&token='+token);
		}
	}
	return oldQuote;
});

vendorServices.factory('saveCategory',function($http,config) {
	var saveCategory = function(token,id) {
		return $http({
			method: 'post',
			url: config.domain + '/api/v1/vendor/save_categoy?version=1.1&token='+token,
			data: {
				'category_id': id
			}
		})
	}
	return saveCategory;
});

vendorServices.factory('getVendorServices',function($http,config) {
	var getVendorServices = function(token,vendorCategoryId) {
		return $http.get(config.domain + '/api/v1/photographer/getpricing?version=1.1&token='+token+'&vendor_category_id='+vendorCategoryId);
	}
	return getVendorServices;
});

vendorServices.factory('postPriceService',function($http,config) {
	var postPriceService = function(token,data) {
		return $http({
			method: 'post',
			url: config.domain + '/api/v1/photographer/savepricing?version=1.1&token='+token,
			data: data
		})
	}
	return postPriceService;
});

vendorServices.factory('venueDetail',function($http,config) {
	var venueDetail = function(token,id) {
		return $http.get(config.domain + '/api/v1/venue/get?version=1.1&token='+token+'&vendor_id='+id)
	}
	return venueDetail;
});

vendorServices.factory('getBookingLead', function($http, config) {
    console.log("services")
    var getBookingLead = function(token,bookingHash) {
        return $http.get(config.domain + '/api/v1/transaction/checkout?version=1.1&token='+token+'&booking_hash='+bookingHash);
    }
    return getBookingLead;
});
vendorServices.factory('getResponse', function($http, config) {
    console.log("services")
    var getResponse = function(token,visibleId) {
        return $http.get(config.domain + '/api/v1/transaction/status?version=1.1&token='+token+'&visible_order_id='+visibleId);
    }
    return getResponse;
});

vendorServices.factory('savePreferencesAdmin',function($http,config) {
	var savePreferences = function(token,vendor_id,category_id,step,answers,func_details,bookingLeadId,user_id,status) {
	  if (step == '2') {
			return $http({
				method: 'post',
				url: config.domain + '/api/v1/booking/savepreferences?token='+token,
				data: {
					'vendor_id': vendor_id,
					'vendor_category_id': category_id,
					'step': step,
					'booking_lead_id': bookingLeadId,
					'user_function_details': func_details,
					'admin_call': true,
					'user_profile_id': user_id,
					'status': status
				}
			})
		} else {
			return $http({
				method: 'post',
				url: config.domain + '/api/v1/booking/savepreferences?token='+token,
				data: {
					'vendor_id': vendor_id,
					'vendor_category_id': category_id,
					'step': step,
					'booking_lead_id': bookingLeadId,
					'user_answers': answers,
					'admin_call': true,
					'user_profile_id': user_id,
					'status': status
				}
			})
		}
	}
	return savePreferences;
});

vendorServices.factory('getQuotePreferenceAdmin',function($http,config) {
	var getQuotePreference = function(token,vendor_id,category_id,price,bookingLeadId,addInfo,user_id) {
	return $http({
			method: 'post',
			url: config.domain + '/api/v1/booking/getquote?token='+token,
			data: {
				'vendor_id': vendor_id,
				'vendor_category': category_id,
				'calculated_price': price,
				'booking_lead_id': bookingLeadId,
				'notes': addInfo,
				'user_profile_id': user_id,
				'admin_call': true
			}
		})
	}
	return getQuotePreference;
})

vendorServices.factory('payVendorCheckout',function($http,config) {
	var payVendorCheckout = function(token,orderId,visibleId) {
	return $http({
			method: 'post',
			url: config.domain + '/api/v1/transaction/savepayment?version=1.1&token='+token,
			data: {
				'order_id': orderId,
				'visible_order_id': visibleId,
			}
		})
	}
	return payVendorCheckout;
})

vendorServices.factory('getVendorBooking',function($http,config) {
	var getVendorBooking = function(token, isComplete) {
		return $http.get(config.domain + '/api/v2/transaction/vendor_bookings?token=' + token + '&get_complete=' + isComplete)
	}
	return getVendorBooking;
});

vendorServices.factory('postAcceptPrice',function($http,config) {
	var postAcceptPrice = function(token, bookingLeadId, historyStatus, updateStatus, updatePrice, userProfileId, extraDetail, previousPrice) {
	return $http({
			method: 'post',
			url: config.domain + '/api/v1/booking/reply?token='+token,
			data: {
				'user_id' : userProfileId,
				'booking_lead_id' : bookingLeadId,
				'status': updateStatus,
				'set_calculated_price':  updatePrice,
				'history_status' : historyStatus,
				'notes' : extraDetail,
				'previous_price_quote' : previousPrice
			}
		})
	}
	return postAcceptPrice;
});

vendorServices.factory('imageOrder',function($http,config) {
	var imageOrder = function(token,imagesArray) {
		var newArr = [];
		imagesArray.forEach(function(x) {
			newArr.push({
				image_id: x.image_id,
				image_order: x.image_order,
			});
		})
		return $http({
			method: 'post',
			url: config.domain + '/api/v1/vendor/image/order?version=1.1&token='+ token,
			data: {
				images: newArr
			}
		})
	}
	return imageOrder;
})

vendorServices.factory('albumOrder',function($http,config) {
	var albumOrder = function(token,imagesArray) {
		return $http({
			method: 'post',
			url: config.domain + '/api/v1/vendor/project/order?version=1.1&token='+ token,
			data: {
				albums: imagesArray
			}
		})
	};
	return albumOrder;
})

vendorServices.factory('requestCalender',function($http,config) {
	var requestCalender = function(token,imagesArray) {
		return $http({
			method: 'post',
			url: config.domain + '/api/v1/request_calendar_feature?version=1.1&token='+ token
		})
	};
	return requestCalender;
})

vendorServices.factory('packageSelection',function($http,config) {
	var packageSelection = function(memb_id) {
		return $http.get(config.domain + '/api/v1/vendor/membership/package/selection?version=1.1&token='+config.vtoken+'&membership_id='+memb_id);
	}
	return packageSelection;
});

vendorServices.factory('packageSelectionDet',function($http,config) {
	var packageSelectionDet = function(package_id) {
		return $http.get(config.domain + '/api/v1/vendor/membership/checkout?version=1.1&token='+config.vtoken+'&package_id='+package_id);
	}
	return packageSelectionDet;
});

vendorServices.factory('membPayNow',function($http,config) {
	var membPayNow = function(order_id) {
		return $http.get(config.domain + '/api/v1/vendor/membership/payment?version=1.1&token='+ config.vtoken+'&order_id='+order_id);
	}
	return membPayNow;
});

vendorServices.factory('paymentStatus',function($http,config) {
	var paymentStatus = function(order_id) {
		return $http.get(config.domain + '/api/v1/vendor/membership/transaction/status?version=1.1&token='+config.vtoken+'&visible_order_id='+order_id);
	}
	return paymentStatus;
});

vendorServices.factory('cancelPackage',function($http,config) {
	var cancelPackage = function(package_id) {
		return $http.get(config.domain + '/api/v1/vendor/subscription/cancel?version=1.1&token='+config.vtoken+'&package_id='+ package_id);
	}
	return cancelPackage;
});

vendorServices.factory('addSecondaryEmail', function($http,config) {
    var addSecondaryEmail = function(email) {
        
        return $http({
            method: 'post',
            url: config.domain + '/node/v1/secondary-email',
            data: {email: email},
            headers: {
                'token': config.vtoken
              },
          })

    }
    return addSecondaryEmail;
});

vendorServices.factory('sendOtpEmail', function($http,config, $q) {
    var sendOtpEmail = function(email) {
        
        var member_id = JSON.parse(localStorage.getItem('redux')).profile.profile.member_id;
        
        return $http({
            method: 'post',
            url: config.domain + '/node/v1/vendor/otp-send',
            headers: {
                'token': config.vtoken
              },
            data: {email: email, member_id: member_id}
          })
    }
    return sendOtpEmail;
});

vendorServices.factory('addPrimaryEmail', function($http,config) {
    var addPrimaryEmail = function(email, otp) {
        
        return $http({
            method: 'post',
            url: config.domain + '/node/v2/primary-detail',
            data: {email: email, otp: otp},
            headers: {
                'token': config.vtoken
              },
          })

    }
    return addPrimaryEmail;
});